import { combineReducers } from 'redux';

import activeTaskReducer from '../store/activeTask';
import appInfo from '../store/appInfo/index';
import currentUserReducer from '../store/currentUser';
import filtersReducer from '../store/filters';

import budgetSiteReducer from './budgetSiteReducer/budgetSiteReducer';
import forecastingReducer from './forecasting/forecastingReducer';
import studyBudgetReducer from './studyBudgetReducers/studyBudgetReducer';
import aiAnalyticsReducer from './aiAnalyticsReducer';
import homePageDashboardsConfig from './homePageDashboardsConfig';
import userPreferencesReducer from './userPreferencesReducer';

const rootReducer = combineReducers({
  currentUser: currentUserReducer,
  forecasting: forecastingReducer,
  budgetList: studyBudgetReducer,
  budgetSitesList: budgetSiteReducer,
  filters: filtersReducer,
  userPreferences: userPreferencesReducer,
  homePageDashboardsConfig,
  appInfo,
  activeTask: activeTaskReducer,
  aiAnalytics: aiAnalyticsReducer
});

export default rootReducer;
